// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"3136":"9be35d46","7942":"9be35d46"}[chunkId] + ".css";
};